import { useContext, Suspense } from "react";
import { Outlet } from "react-router";
import { LayoutContext } from "../../../context/LayoutContext";
import Notification from "./Notification";
import PricingPlansDialog from "../../PricingAndCheckout/PricingPlansDialog";
import FreeTrialWelcomeDialog from "../../FreeTrialWelcomeDialog";
import TrialEndDialog from "../../TrialEndDialog";
import MeteringUpgradeModal from "./Metering/MeteringUpgradeModal";

export default function IndividualEntityPage() {
    const { notifications, closeNotification } = useContext(LayoutContext);

    return (
        <div
            id="app-shell"
            className="grid duration-300 ease-in-out"
            style={{
                gridTemplateColumns: `auto`,
            }}
        >
            <div className="flex min-w-0 justify-stretch">
                <Suspense>
                    <div id="route-content" className="grow sm:h-screen sm:overflow-auto sm:px-3">
                        <Outlet />
                        <PricingPlansDialog />
                        <FreeTrialWelcomeDialog />
                        <TrialEndDialog />
                        <MeteringUpgradeModal />
                        <div className="fixed inset-x-0 bottom-0 z-50 flex flex-col items-center justify-center">
                            {notifications.map(notification => (
                                <Notification key={notification.id} notification={notification} closeNotification={closeNotification} />
                            ))}
                        </div>
                    </div>
                </Suspense>
            </div>
        </div>
    );
}
